import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const isPreviewFrame = new URLSearchParams(window.location.search).get('preview') === 'embed';
const showResponsivePreview = process.env.NODE_ENV !== 'production' && !isPreviewFrame;
// Local development renders the preview shell; production renders App directly.
const ResponsivePreview = showResponsivePreview
  ? require('./ResponsivePreview').default
  : null;

root.render(
  <React.StrictMode>
    {showResponsivePreview ? <ResponsivePreview /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
